import {FC, SVGProps} from 'react';
import styles from './IdentityVerificationPendingBanner.module.css';

const DocumentsCheckingIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path
			d="M18 10H42L54 22V62H18V10Z"
			stroke="currentColor"
			strokeWidth="2.2"
			strokeLinejoin="round"
		/>
		<path d="M42 10V22H54" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
		<path d="M26 32H46" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
		<path d="M26 40H46" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
		<path d="M26 48H38" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
		<path
			d="M48 44C48 40.6863 50.6863 38 54 38C57.3137 38 60 40.6863 60 44C60 46.2091 58.2091 48 56 48H52C49.7909 48 48 46.2091 48 44Z"
			stroke="currentColor"
			strokeWidth="2.2"
		/>
		<path d="M54 41.5V44.5L56 46" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const IdentityVerificationPendingBanner: FC = () => {
	return (
		<section className={styles.banner} aria-live="polite">
			<div className={styles.text}>
				<h2 className={styles.title}>Проверяем ваши документы</h2>
				<p className={styles.subtitle}>Подождите, пока закончится проверка</p>
			</div>
			<span className={styles.iconWrap}>
				<DocumentsCheckingIcon className={styles.icon} />
			</span>
		</section>
	);
};
